import { format } from 'date-fns';
import checkAccess from '../../../utils/roles/checkAccess';
import getFranchiseRegion from '../../../utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/Orders',
};

export const getColumns = ({ viewOrder }) => [
  { id: 'number', label: 'Order Nr', align: 'left' },
  { id: 'status', label: 'Status', align: 'center' },
  { id: 'qtyItems', label: 'Items Quantity', align: 'center', disableSort: true },
  { id: 'region', label: 'Region', align: 'center', disableSort: true },
  {
    id: 'createdAt',
    label: 'Date',
    customValue: (val) => format(new Date(val.createdAt), 'E, dd MMM yyyy p'),
    align: 'center',
    nameForSort: 'created_at',
  },
  {
    id: 'more-menu',
    type: 'menu',
    items: [{ id: 1, name: 'Order View', action: viewOrder, icon: 'eva:edit-fill' }],
    disableSort: true,
  },
];

export const getFilters = ({ searchBy, region, vendorId, status, dateRange, options }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Search by Order number',
    action: searchBy.change,
  },
  {
    id: 'dateRange',
    variant: 'dateTime',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
  {
    id: 'region',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
  {
    id: 'status',
    type: 'select',
    label: 'Status',
    value: status.value,
    action: status.change,
    items: options?.statuses?.length ? ['all', ...options.statuses] : ['all'],
  },
  {
    id: 'vendor',
    type: 'select',
    label: 'Vendor',
    value: vendorId.value,
    action: vendorId.change,
    items: options?.vendors?.length ? ['all', ...options.vendors] : ['all'],
  },
];
